<template>
  <DrawerHeader @close="handleEscape">Tip</DrawerHeader>

  <div class="flex flex-1 items-center justify-center">
    <p class="px-4 text-center text-lg font-normal">
      Would you like to leave a tip?
    </p>
  </div>
  <div
    class="flex flex-1 flex-col items-stretch justify-end"
  >
    <template v-if="step === 'select'">
      <div class="space-y-4 p-4">
        <template
          v-for="option in options"
          :key="option.label"
        >
          <ActionButtonSecondary
            class="block w-full py-4"
            @click="handleSubmit(option.value)"
          >
            {{ option.label }}
          </ActionButtonSecondary>
        </template>
        <ActionButtonPrimary
          class="block w-full py-4"
          @click="handleGoToCustomAmount"
        >
          Custom Amount
        </ActionButtonPrimary>
      </div>
    </template>
    <template v-else-if="step === 'custom'">
      <div class="px-6">
        <div class="flex flex-1 flex-col justify-center">
          <div class="relative">
            <CustomAmountDisplay
              class=""
              :value="customAmount"
            />
            <p
              v-if="customAmountIsInvalid"
              class="absolute text-center text-xs text-error"
              >Tip amount must not be greater than 50% of
              the sale amount</p
            >
          </div>
        </div>
        <BaseNumpad v-model="customAmount" />
      </div>
      <div
        class="flex flex-col justify-center space-y-3 p-4"
      >
        <ActionButtonPrimary
          :disabled="customAmountIsInvalid"
          @click="handleSubmitCustomAmount"
        >
          Submit
        </ActionButtonPrimary>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>
<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()
const { gratuityOptionsList } = useTenant()
const props = defineProps<{
  amountGross: number
}>()

const emit = defineEmits<{
  (event: "submit", amount: number): void
  (event: "cancel"): void
}>()

const { platform } = useDevice()

const getGratuity = (percentage: number) =>
  computed(() =>
    Math.ceil((props.amountGross * percentage) / 100)
  )

const nonZeroGratuityOptions = computed(() =>
  gratuityOptionsList.value
    .filter((option) => option != 0)
    .map((option) => ({
      label: `${option}%  - ${formatToMerchantCurrencyString(
        getGratuity(option).value
      )}`,
      value: getGratuity(option).value,
    }))
)

const options = computed(() => [
  {
    label: "No Thanks",
    value: 0,
  },
  ...nonZeroGratuityOptions.value,
])

const handleSubmit = (value: number) => {
  emit("submit", value)
}

const handleGoToCustomAmount = () => {
  step.value = "custom"
}

type Step = "select" | "custom"
const step = ref<Step>("select")

const customAmount = ref(0)
const customAmountIsInvalid = computed(
  () =>
    platform === "paxEvo" &&
    customAmount.value > props.amountGross / 2
)

const handleSubmitCustomAmount = () => {
  handleSubmit(customAmount.value)
  customAmount.value = 0
  step.value = "select"
}

const handleEscape = () => {
  step.value === "select"
    ? emit("cancel")
    : (step.value = "select")
}
</script>
